import { HeadCell } from '../../../types/grid';

export const TABLE_HEAD_LIST: readonly HeadCell[] = [
  { id: 'id', label: '#' },
  { id: 'firstName', label: 'First Name' },
  { id: 'lastName', label: 'Last Name' },
  { id: 'email', label: 'Email' },
  { id: 'country', label: 'Country' },
  { id: 'model', label: 'Model' },
  { id: 'datePurchase', label: 'Date of Purchase' },
  { id: 'createdAt', label: 'Date of Registration' },
] as const;
